module.exports = __webpack_public_path__ + "img/straightDown_bg.d6e78e24.png";